export default {
  default: () => import("/var/www/apps/front-office/layouts/default.vue").then(m => m.default || m),
  minimal: () => import("/var/www/apps/front-office/layouts/minimal.vue").then(m => m.default || m)
}